import React from 'react';
import {Head} from 'react-static';

export default function PageMeta({
  url = 'https://brain.foodrevolution.org/masterclaass/',
  ogImage = 'https://cdn.foodrevolution.org/hbc/og/hbc-open-graph-20200903-evergreen-masterclass-fbt.jpg',
  title = 'Join the FREE Brain Breakthroughs Masterclass.',
  description = 'Discover the key to thriving brain health at any age with FRN CEO, Ocean Robbins, and leading neurologists Dean and Ayesha Sherzai, MD in this free Masterclass.'
}) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:site" content="@afoodrevolution" />
      <meta property="twitter:image" content={ogImage} />
      <meta property="fb:app_id" content="1685199371775570" />
      <meta property="og:site_name" content="Join the FREE Brain Breakthroughs Masterclass." />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
    </Head>
  );
}
